import React from 'react';
import { Route, Switch } from 'react-router-dom';

import DSRHome from '../../components/DSRHome';
import DSRTable from '../../components/DSRTable';

const DailySalesRecord = ({ match }) => {
  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <DSRHome {...props} />;
          }}
        />
        <Route
          path={`${match.url}/allrecords`}
          exact
          render={(props) => {
            return <DSRTable {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default DailySalesRecord;
